<template>
  <div class="">
    <div class="row my-4">
      <!-- First Column -->

      <div class="col-md-6 col-lg-6 col-sm-12">
        <v-container v-if="progress" type="image" class="loding">
          <v-skeleton-loader type="image"></v-skeleton-loader>
          <v-skeleton-loader type="image"></v-skeleton-loader>
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-container>
        <form v-else>
          <div class="background-white mt-3">
            <div class="title">
              <div class="position">{{ $t("REGULATION") }}</div>
            </div>
          </div>
          <div class="center borderPointier mt-3 p-3">
            <b-form-group :label="$t('Debut travaux')" class="mt-2">
              <b-form-input
                type="date"
                v-model="getdevisMonoFiche.data.devis.debut_travaux"
                required
                class="form-input custom-placeholder custom-input"
                @input="
                  updateDevis(
                    'debut_travaux',
                    getdevisMonoFiche.data.devis.debut_travaux
                  )
                "
              ></b-form-input>
            </b-form-group>

            <b-form-group :label="$t('Fin travaux')">
              <b-form-input
                type="date"
                v-model="getdevisMonoFiche.data.devis.fin_travaux"
                required
                @input="
                  updateDevis(
                    'fin_travaux',
                    getdevisMonoFiche.data.devis.fin_travaux
                  )
                "
                class="form-input custom-placeholder custom-input"
              ></b-form-input>
            </b-form-group>
              <b-form-group
              v-if="isFactureDocument"
              :label="$t('Type de facture') || 'Type de facture'"
            >
              <b-form-select
                v-model="factureType"
                :options="factureTypeOptions"
                :placeholder="'Choisir...'"
                class="form-input custom-placeholder custom-input"
                @change="updateFactureType"
              ></b-form-select>
            </b-form-group>
            <div class="mb-3">
              <div class="fieldset mt-3">
                <div class="legend mb-2">{{ $t("MOD_PAYMENT") }}</div>

                <multiselect
                  v-model="selectedMoyensPaiement"
                  :searchable="false"
                  :close-on-select="true"
                  :options="optionspaiement"
                  :multiple="true"
                  :placeholder="$t('sélectionnez_moy')"
                  label="text"
                  track-by="value"
                  required
                  class="form-input custom-placeholder custom-input custom-margin-bottom"
                ></multiselect>

              </div>
            </div>
          
          </div>
        </form>
      </div>

      <!-- Second Column -->
      <div class="col-md-6 col-lg-6 col-sm-12">
        <v-container v-if="progress" type="image" class="loding">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-container>

        <form v-else>
          <div class="background-white mt-3">
            <div class="title">
              <div class="position">
                {{ $t("AGENT") }}/{{ $t("DELEGATAIRE") }}/{{ $t("oblige") }}
              </div>
            </div>
          </div>
          <div class="borderPointier mt-3 pt-3 px-3">
            <b-form-group
  label="Type *"
  label-for="radio-type"
  :state="isTypeValid"
  invalid-feedback="Vous devez sélectionner un type"
>
  <b-form-radio-group
    id="radio-type"
    v-model="selectedType"
    :options="typeOptions"
    name="typeRadios"
    required
    @change="validateType"
  ></b-form-radio-group>
</b-form-group>
<div class="d-flex justify-content-between" v-if="selectedType === 'mandataire_delegataire'">
              <div class="">{{ $t("AGENT") }}/{{ $t("DELEGATAIRE") }}</div>
              <button id="add-with-popover"
                class="mb-1 py-0 newstore rounded"
                @click.prevent="openModal('add')"
              >
               +
              </button>
              <b-popover
      target="add-with-popover"
      placement="top"
      triggers="hover focus click"
    >
    {{ $t("Vous pouvez ajouter un nouveau Mandataire/Délégataire") }}
    </b-popover>
              <mandataireEtpartenairemodale
                v-if="isModalOpen"
                :isOpen="isModalOpen"
                :updateEntrepriseId="getdevisMonoFiche.data.devis.entreprise.id"
                @close="closeModal"
                @confirm="handleConfirm"
                :updateData="update_EntiteExterne"
              ></mandataireEtpartenairemodale>
            </div>
            
            <b-form-group v-if="selectedType === 'mandataire_delegataire'">
              <multiselect
                v-model="selectedMondataire"
                :searchable="true"
                :close-on-select="true"
                :multiple="false"
                :options="getMondataireEntitesExternes"
                label="nom"
                track-by="id"
                :placeholder="$t('Select_agent') + '/' + $t('DELEGATAIRE')"
                class="form-input custom-placeholder custom-input"
              />
        
            </b-form-group>
            <b-form-group v-if="selectedType === 'mandataire_delegataire' && selectedMondataire">
              <label>{{ $t("Configuration") }}</label>
              <div v-if="getLoadingConfiguration" class="text-center p-2">
                <b-spinner small></b-spinner>
                <small class="ml-2">{{ $t("Chargement des configurations...") }}</small>
              </div>
              <multiselect
                v-else
                v-model="selectedConfig"
                :searchable="true"
                :close-on-select="true"
                :multiple="false"
                :options="configsOptions"
                label="label"
                track-by="id"
                :placeholder="configsOptions.length > 0 ? $t('Sélectionner une configuration') : $t('Aucune configuration disponible')"
                :disabled="configsOptions.length === 0"
                class="form-input custom-placeholder custom-input"
              />
              <small v-if="!getLoadingConfiguration && configsOptions.length === 0" class="text-muted">
                {{ $t("Aucune configuration disponible pour cette entité") }}
              </small>
            </b-form-group>
            <div v-if="selectedType === 'oblige'">
              <div class="d-flex justify-content-between" >
              <div class="">{{ $t("oblige") }}</div>
              <button id="addoblige-with-popover"
                class="mb-1 py-0 newstore rounded"
                @click.prevent="openModal('add')"
              >
                +
              </button>
              <b-popover
      target="addoblige-with-popover"
   
      placement="top"
      triggers="hover focus"
    >
    Vous pouvez ajouter un nouveau oblige
    </b-popover>
            </div>
             <b-form-group >
              <multiselect
                v-model="selectedPartenaire"
                :searchable="true"
                :close-on-select="true"
                :multiple="false"
                :options="getPartenaireEntitesExternes"
                label="nom"
                track-by="id"
                :placeholder="$t('Select_oblige')"
                class="form-input custom-placeholder custom-input"
              />
            </b-form-group>
            <b-form-group v-if="selectedType === 'oblige' && selectedPartenaire">
              <label>{{ $t("Configuration") }}</label>
              <div v-if="getLoadingConfiguration" class="text-center p-2">
                <b-spinner small></b-spinner>
                <small class="ml-2">{{ $t("Chargement des configurations...") }}</small>
              </div>
              <multiselect
                v-else
                v-model="selectedConfig"
                :searchable="true"
                :close-on-select="true"
                :multiple="false"
                :options="configsOptions"
                label="label"
                track-by="id"
                :placeholder="configsOptions.length > 0 ? $t('Sélectionner une configuration') : $t('Aucune configuration disponible')"
                :disabled="configsOptions.length === 0"
                class="form-input custom-placeholder custom-input"
              />
              <small v-if="!getLoadingConfiguration && configsOptions.length === 0" class="text-muted">
                {{ $t("Aucune configuration disponible pour cette entité") }}
              </small>
            </b-form-group></div>
          </div>
          <!-- <v-container v-if="progress" type="image" class="loding">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </v-container>
          <div v-else class="borderPointier mt-3 pt-3 px-3">
            <div class="background-white">
              <div class="title">
                <div class="position">{{ $t("oblige") }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="">{{ $t("oblige") }}</div>
              <button id="addoblige-with-popover"
                class="mb-1 py-0 newstore rounded"
                @click.prevent="openModal('add')"
              >
                +
              </button>
              <b-popover
      target="addoblige-with-popover"
   
      placement="top"
      triggers="hover focus"
    >
    Vous pouvez ajouter un nouveau oblige
    </b-popover>
            </div>
            <b-form-group>
              <multiselect
                v-model="selectedPartenaire"
                :searchable="true"
                :close-on-select="true"
                :multiple="false"
                :options="getPartenaireEntitesExternes"
                label="nom"
                track-by="id"
                :placeholder="$t('Select_oblige')"
                class="form-input custom-placeholder custom-input"
              />
            </b-form-group>
          </div> -->
        </form>
      </div>
    </div>
    <!--button-->
    <div class="d-flex justify-content-end mt-5">
      <b-button @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>
      <b-button
        type="submit"
        @click="goToNextStep"
        class="button-suivant-style m-3"
      >
        {{ $t("NEXT") }}
        <div class="loading ml-2" v-if="isLoading">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
        <div class="loading ml-2" v-if="isLoadingButton">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      </b-button>
    </div>
    <Snackbar ref="snackbar" class="mt-5" />
  </div>
</template>
<script>
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import domain from "@/environment";
import axios from "axios";
import mandataireEtpartenairemodale from "@/components/Ajoutmodel/mandataireEtpartenairemodale.vue";
import Snackbar from "@/components/ui/errorSnackbar.vue";
export default {
  components: {
    Snackbar,
    mandataireEtpartenairemodale,
  },
  props: {
    isLoadingButton: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
       selectedType: null,
    isTypeValid: null,
    typeOptions: [
      { text: "Mandataire / Délégataire", value: "mandataire_delegataire" },
      { text: "Obligé", value: "oblige" },
    ],
      update_EntiteExterne: null,
      paiement_state: [],
      isLoading: false,
      selectedMoyensPaiement: [],
      partenaire: false,
      mondataire: false,
      isModalOpen: false,
      optionspaiement: [
        {
          value: "Organisme_de_financement",
          text: this.$t("Organisme_de_financement"),
        },
        {
          value: "cheque_virement_espece",
          text: this.$t("Cheque_virement_espece"),
        },
        {
          value: "Certificat_Economie_energie",
          text: this.$t("Certificat_Economie_energie"),
        },
        {
          value: "Ma_prime_renove",
          text: this.$t("Ma_prime_renove"),
        },
        {
          value: "coupDePouce",
          text: this.$t("coup De Pouce"),
        },
        
        {
          value: "Autre",
          text: this.$t("Autre"),
        },
      ],
      factureType: null,
      factureTypeOptions: [
        { value: "facture.acompte", text: "Facture d'acompte" },
        { value: "facture.fin-travaux", text: "Facture fin travaux" },
      ],
      optionsTypeClient: [
        { value: "type.particulier", text: this.$t("PARTICULAR") },
        { value: "type.professionnel", text: this.$t("PROFESSIONAL") },
      ],
      selectedConfig: null,
      isInitializingConfig: false,
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.token,
    }),
    ...mapGetters([
      "getdevisMonoFiche",
      "getMondataireEntitesExternes",
      "getPartenaireEntitesExternes",
      "getOnlineUser",
      "getAllConfigurations",
      "getLoadingConfiguration",
      "getAlldossiers",
    ]),
    isentrepriseAdmin() {
      return this.getOnlineUser.role == "user.entreprise-admin";
    },
    isCommercialBatigo() {
      return this.getOnlineUser.role == "user.commercial-batigo";
    },
    isAssistant() {
      return this.getOnlineUser.role == "user.assistant";
    },
    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    devisData() {
      return this.getdevisMonoFiche?.data?.devis || {};
    },
    selectedPartenaire: {
      get() {
        if (typeof this.partenaire === "object" && this.partenaire !== null) {
          return this.partenaire;
        } else {
          return this.getPartenaireEntitesExternes.find(
            (option) => option.id === this.partenaire
          );
        }
      },
      set(value) {
     
        this.partenaire = value ? value.id : null;
        this.getdevisMonoFiche.data.devis.partenaire_id = value
          ? value.id
          : null;
 
        if (value && value.id) {
          this.getdevisMonoFiche.data.devis.partenaire = {
            id: value.id,
            nom: value.nom,
            siret: value.siret,
          };
          // Réinitialiser la configuration quand on change d'entité
          this.selectedConfig = null;
          this.getdevisMonoFiche.data.devis.configuration_id = null;
          // Charger les configs de l'entité sélectionnée
          this.loadConfigsForEntity(value.id);
        } else {
          this.getdevisMonoFiche.data.devis.partenaire = null;
          this.selectedConfig = null;
          if (this.getdevisMonoFiche?.data?.devis) {
            this.getdevisMonoFiche.data.devis.configuration_id = null;
          }
        }
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      },
    },
    selectedMondataire: {
      get() {
        if (typeof this.mondataire === "object" && this.mondataire !== null) {
          return this.mondataire;
        } else {
          return this.getMondataireEntitesExternes.find(
            (option) => option.id === this.mondataire
          );
        }
      },
      set(value) {
        if (value && value.id) {
          this.mandataire = value.id;
          this.getdevisMonoFiche.data.devis.mandataire_id = value.id;
          this.getdevisMonoFiche.data.devis.mandataire = {
            id: value.id,
            nom: value.nom || "",
            siret: value.siret || "",
          };
          // Réinitialiser la configuration quand on change d'entité
          this.selectedConfig = null;
          this.getdevisMonoFiche.data.devis.configuration_id = null;
          // Charger les configs de l'entité sélectionnée
          this.loadConfigsForEntity(value.id);
        } else {
          this.mandataire = null;
          this.getdevisMonoFiche.data.devis.mandataire_id = null;
          this.getdevisMonoFiche.data.devis.mandataire = null;
          this.selectedConfig = null;
          if (this.getdevisMonoFiche?.data?.devis) {
            this.getdevisMonoFiche.data.devis.configuration_id = null;
          }
        }

        this.setDevisMonoFiche(this.getdevisMonoFiche);
      },
    },
    isFactureDocument() {
      const type = this.getdevisMonoFiche?.data?.devis?.type || "";
      return type.toLowerCase().includes("facture");
    },
    clientIdForDossiers() {
      const devis = this.getdevisMonoFiche?.data?.devis;
      return devis?.client_id || devis?.client?.id || null;
    },
    dossiersOptions() {
      const list = this.getAlldossiers || [];
      const clientId = this.clientIdForDossiers;
      if (!clientId) return [];
      return list.filter((d) => (d.client_id || d.client?.id) == clientId);
    },
    selectedDossiers: {
      get() {
        const ids = this.getdevisMonoFiche?.data?.devis?.ocr_dossier_ids;
        if (!Array.isArray(ids) || ids.length === 0) return [];
        const opts = this.dossiersOptions;
        return ids
          .map((id) => opts.find((d) => d.id == id))
          .filter(Boolean);
      },
      set(val) {
        const devis = this.getdevisMonoFiche?.data?.devis;
        if (!devis) return;
        devis.ocr_dossier_ids = Array.isArray(val)
          ? val.map((d) => d.id).filter(Boolean)
          : [];
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      },
    },
    configsOptions() {
      const allConfigs = this.getAllConfigurations || [];
      if (allConfigs.length === 0) return [];
      
      // Récupérer le type_group du devis depuis groupeLigneDocument
      const groupeLigneDocument = this.getdevisMonoFiche?.data?.groupeLigneDocument || [];
      const devisTypes = groupeLigneDocument.map(groupe => groupe.type_group).filter(Boolean);
      
      // Si aucun type n'est trouvé, retourner toutes les configs (ou aucune selon le besoin)
      if (devisTypes.length === 0) {
        return [];
      }
      
      // Date d'aujourd'hui
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      // Filtrer les configurations
      return allConfigs.filter(config => {
        // Vérifier que la configuration est active
        if (config.active === false || config.active === 0) {
          return false;
        }
        
        // Vérifier que le type du devis est dans le tableau type de la config
        const configTypes = config.type || [];
        const hasMatchingType = devisTypes.some(devisType => 
          configTypes.includes(devisType)
        );
        
        if (!hasMatchingType) return false;
        
        // Vérifier que la date d'aujourd'hui est dans la période de validité
        if (config.date_debut && config.date_fin) {
          const dateDebut = new Date(config.date_debut);
          const dateFin = new Date(config.date_fin);
          dateDebut.setHours(0, 0, 0, 0);
          dateFin.setHours(23, 59, 59, 999);
          
          return today >= dateDebut && today <= dateFin;
        }
        
        // Si pas de dates, exclure la config
        return false;
      });
    },
  },

  async created() {
    this.loadDossiersForClient();
    const devi_ID = this.getdevisMonoFiche.data?.devis?.id;
    
      const data = await this.getPaiement(devi_ID);
      this.paiement_state = data;

  
      const moyensPaiement = Array.from(
        new Set(this.paiement_state.map((item) => item.moyen_paiement))
      );

      this.selectedMoyensPaiement = moyensPaiement
        .map((moyen) => {
          const option = this.optionspaiement.find(
            (option) => option.value === moyen
          );
          return option ? { value: option.value, text: option.text } : null;
        })
        .filter((moyen) => moyen !== null);
   

    if (this.isSuperAdmin) {
      this.allEntitesExternes({
        page: this.page,
        per_page: 100000000000,
        nom: this.nom,
        entreprise_id: this.getdevisMonoFiche.data.devis.entreprise.id,
      });
    } else {
      this.allEntitesExternes({
        page: 1,
        per_page: 1000000000,
        search: "",
        type: "",
        entreprise_id: this.getOnlineUser.entreprise.id,
      });
    }
    if (this.getdevisMonoFiche.data && this.getdevisMonoFiche.data.devis) {
      this.initializeDateData();
      this.formatDates();
    }
  },
  watch: {
    clientIdForDossiers: {
      handler(clientId) {
        if (clientId) this.loadDossiersForClient();
      },
    },
    getdevisMonoFiche: {
      handler(newVal) {
        if (newVal?.data?.devis) {
          this.partenaire = newVal.data.devis.partenaire || null;
          this.mondataire = newVal.data.devis.mandataire || null;
          if(this.partenaire){
this.selectedType="oblige"
this.isTypeValid=true
          }else{
            this.selectedType="mandataire_delegataire"
            this.isTypeValid=true
          }
          
          this.factureType = newVal.data.devis.typeFacture || null;
          this.formatDates();
          
          // Initialiser la configuration sélectionnée si elle existe
          if (newVal.data.devis.configuration_id) {
            const configId = newVal.data.devis.configuration_id;
            const entiteId = this.partenaire?.id || this.mondataire?.id || 
                            newVal.data.devis.partenaire_id || newVal.data.devis.mandataire_id;
            
            this.isInitializingConfig = true;
            if (entiteId) {
              // Charger les configurations de l'entité puis initialiser
              this.loadConfigsForEntity(entiteId).then(() => {
                const config = (this.getAllConfigurations || []).find(c => c.id === configId);
                if (config) {
                  this.selectedConfig = config;
                }
                this.isInitializingConfig = false;
              });
            } else {
              // Si pas d'entité, chercher dans les configs déjà chargées
              const config = (this.getAllConfigurations || []).find(c => c.id === configId);
              if (config) {
                this.selectedConfig = config;
              }
              this.isInitializingConfig = false;
            }
          } else {
            this.selectedConfig = null;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    selectedConfig: {
      handler(newVal) {
        // Ne pas sauvegarder pendant l'initialisation
        if (this.isInitializingConfig) return;
        if (!this.getdevisMonoFiche?.data?.devis) return;
        
        if (newVal && newVal.id) {
          // Sauvegarder l'ID de la configuration dans le devis
          const currentConfigId = this.getdevisMonoFiche.data.devis.configuration_id;
          if (currentConfigId !== newVal.id) {
            this.getdevisMonoFiche.data.devis.configuration_id = newVal.id;
            this.setDevisMonoFiche(this.getdevisMonoFiche);
          }
        } else {
          // Réinitialiser si aucune configuration n'est sélectionnée
          if (this.getdevisMonoFiche.data.devis.configuration_id !== null) {
            this.getdevisMonoFiche.data.devis.configuration_id = null;
            this.setDevisMonoFiche(this.getdevisMonoFiche);
          }
        }
      },
    },
  },

  methods: {
    ...mapActions([
      "allEntitesExternes",
      "setDevisMonoFiche",
      "storeEntiteExterne",
      "allConfigurations",
      "alldossier",
    ]),
     validateType() {
    this.isTypeValid = !!this.selectedType;
  },
    async getPaiement(devis_ID) {
      try {
        const response = await axios.get(domain + `/devis_moyens_paiement`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
          params: {
            devis_id: devis_ID,
          },
        });

        return response.data.data;
      } catch (error) {
        throw new Error(
          error.response?.data?.message ||
            "An error occurred while fetching the payment information."
        );
      }
    },

    setup(refresh = false) {
      if (refresh) this.page = 1;

      if (this.getOnlineUser) {
        this.allEntitesExternes({
          page: this.page,
          per_page: 100000000000,
          entreprise_id: this.getdevisMonoFiche.data.devis.entreprise.id,
        });
      }
    },

    async handleConfirm(EntiteExtData) {
      try {
        await this.storeEntiteExterne(EntiteExtData);
        this.closeModal();
        this.setup(true);
      } catch (err) {
        if (this.isObject(err)) {
          for (const [key, value] of Object.entries(err)) {
            if (!this.erreurlist[key]) {
              this.erreurlist[key] = value;
            }
          }
        } else {
          this.errorS = err;
        }
      }
    },
    async postPaiement(payload) {
      const responses = [];
      for (const item of payload) {
        try {
          const dataToSend = {
            devis_id: this.getdevisMonoFiche.data.devis.id,
            moyen_paiement: item,
          };

          const response = await axios.post(
            domain + `/devis_moyens_paiement`,
            dataToSend,
            {
              headers: {
                Authorization: `Bearer ` + this.token,
              },
            }
          );

          responses.push(response);
        } catch (error) {
          throw new Error("Failed to post payment.");
        }
      }
      return responses;
    },
    openModal(action, updateData = null) {
      console.log('open')
      this.update_EntiteExterne = updateData;
      console.log(' this.update_EntiteExterne 0', this.update_EntiteExterne )
      this.isModalOpen = true;
      console.log('this.isModalOpen',this.isModalOpen)
    },
    closeModal() {
      this.isModalOpen = false;
      this.update_EntiteExterne = null;
    },
    async deletePaiement(ids) {
      const responses = [];

      for (const id of ids) {
        try {
          const response = await axios.delete(
            domain + `/devis_moyens_paiement/${id}`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            }
          );
          responses.push(response.data);
        } catch (error) {
          responses.push({
            id,
            error:
              error.response?.data?.message ||
              "An error occurred while deleting the payment.",
          });
        }
      }

      return responses;
    },
    paiement() {
      if (!this.paiement_state || !Array.isArray(this.paiement_state)) {
        return;
      }

      const selectedValues =
        this.selectedMoyensPaiement?.map((option) => option.value) || [];

      const idsExistants = selectedValues.filter(
        (moyen_paiement) =>
          !this.paiement_state.some(
            (obj) => obj.moyen_paiement === moyen_paiement
          )
      );

      if (idsExistants) {
        this.postPaiement(idsExistants);
      }

      const idsNonExistants = this.paiement_state
        .filter(
          (obj) =>
            !this.selectedMoyensPaiement.some(
              (moyen) => moyen.value === obj.moyen_paiement
            )
        )
        .map((obj) => obj.id);

      if (idsNonExistants) {
        this.deletePaiement(idsNonExistants);
      }
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY");
    },
    goToNextStep() {
      this.isLoading = true;
      this.paiement();
      this.setDevisMonoFiche(this.getdevisMonoFiche);
      const debutTravaux = new Date(
        this.getdevisMonoFiche?.data?.devis?.debut_travaux
      );
      const finTravaux = new Date(
        this.getdevisMonoFiche?.data?.devis?.fin_travaux
      );
      const debutDevis = new Date(
        this.getdevisMonoFiche?.data?.devis?.debut_devis
      );

      if (debutTravaux < debutDevis) {
       
        this.$refs.snackbar.showSnackbar(
           `${this.$t("error_date_devis")}`
        );
        this.isLoading = false;
        return;
      }
      if (debutTravaux > finTravaux) {
        this.$refs.snackbar.showSnackbar(
           `${this.$t("error_date_travaux")}`
        );
        this.isLoading = false;
        return;
      }
      if ( ( !(this.getdevisMonoFiche.data.devis.partenaire_id || this.getdevisMonoFiche.data.devis.partenaire)&&
  !(this.getdevisMonoFiche.data.devis.mandataire_id || this.getdevisMonoFiche.data.devis.mandataire) )|| 
  this.selectedMoyensPaiement.length === 0
) {
  this.$refs.snackbar.showSnackbar( `${this.$t("error_reglement")}`);
  this.isLoading = false;
  return;
}


      this.isLoading = false;
      this.$emit("changeStep", 7, true);
    },
    goToPrevStep() {
      this.$emit("changeStep", 5);
    },

    initializeDateData() {
      const devis = this.getdevisMonoFiche?.data?.devis;
     
      if (!devis.debut_travaux) {
        devis.debut_travaux = new Date().toISOString().slice(0, 10);
      }

      if (!devis.fin_travaux) {
        devis.fin_travaux = new Date().toISOString().slice(0, 10);
      }
    },

    selectMondataire(mondataire) {
      this.mondataire = { ...mondataire };

      this.getdevisMonoFiche.data.devis.mandataire_id = mondataire.id;
      this.selectedType="mandataire_delegataire"
      this.isTypeValid=true
    },
    updateDevis(field, value) {
      this.getdevisMonoFiche.data.devis[field] = value;

      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },
    selectPartenaire(partenaire) {
      this.partenaire = { ...partenaire };
      this.getdevisMonoFiche.data.devis.partenaire_id = partenaire.id;
      this.selectedType="oblige"
      this.isTypeValid=true

    },
    formatDates() {
      const formatDateLocal = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");

        return `${year}-${month}-${day}`;
      };

      if (this.getdevisMonoFiche?.data?.devis?.fin_travaux) {
        this.getdevisMonoFiche.data.devis.fin_travaux = formatDateLocal(
          this.getdevisMonoFiche?.data?.devis?.fin_travaux
        );
      }

      if (this.getdevisMonoFiche?.data?.devis?.debut_travaux) {
        this.getdevisMonoFiche.data.devis.debut_travaux = formatDateLocal(
          this.getdevisMonoFiche?.data?.devis?.debut_travaux
        );
      }
    },
    updateFactureType() {
      if (!this.isFactureDocument) {
        return;
      }
      this.getdevisMonoFiche.data.devis.typeFacture = this.factureType || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },
    formatDossierLabel(dossier) {
      if (!dossier) return "";
      const name = dossier.name || dossier.numero_dossier || "";
      const num = dossier.numero_dossier && dossier.numero_dossier !== name ? ` (${dossier.numero_dossier})` : "";
      return (name || "Dossier #" + dossier.id) + num;
    },
    async loadDossiersForClient() {
      const clientId = this.clientIdForDossiers;
      if (!clientId) return;
      try {
        await this.alldossier({
          page: 1,
          per_page: 1000,
          client_id: clientId,
        });
      } catch (err) {
        console.error("Erreur chargement dossiers:", err);
      }
    },
    async loadConfigsForEntity(entiteExterneId) {
      try {
        await this.allConfigurations({
          entite_externe_id: entiteExterneId,
          page: 1,
          per_page: 1000,
        });
        // Réinitialiser la sélection de config
        this.selectedConfig = null;
      } catch (error) {
        console.error("Erreur lors du chargement des configurations:", error);
      }
    },
  },
};
</script>
<style scoped>
.custom-margin-bottom {
  margin-bottom: 90px;
}

.borderPointier {
  border: 2px dashed #24316d;
  position: relative;
}
.input-style {
  margin-bottom: 1rem;
  border-radius: 4px;
  border: 1px solid #eaebec;
  padding: 0.5rem 0.75rem;
  background-color: #fff;
}

.background-white {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.title {
  color: #24316d;
  position: relative;
  z-index: 2;
  margin: 0;
}
.newstore {
  background: #24316d;
  padding: 8px 12px;
  color: #fff;
  cursor: pointer;
  width: 30px;
  height: 30px;
  &:hover {
    background-color: #24316d !important;
  }
}
.position {
  background-color: white;
  display: inline-block;
  padding: 0.05rem 2rem;
}
.custom-placeholder::placeholder {
  font-size: 13px;
}
.custom-input {
  box-shadow: none;
}
.form-input {
  font-size: 13px;
  height: 41.1px !important;
}
.small-spinner .spinner-border {
  width: 1rem;
  height: 1rem;
}
</style>
